import { createContext } from 'react';

const LiveTrackingContext = createContext();

export default LiveTrackingContext;
